<template>
  <div class="text-center d-flex align-center justify-space-around">
    <v-tooltip
      left
      color="rgb(45, 43, 43)"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="primary"
          dark
          v-bind="attrs"
          text
          v-on="on"
        >
          详情
        </v-btn>
      </template>
      <!-- style="background: black;" -->
      <div>
        <Effect
          :value="value"
          :show-list="showList"
        />
      </div>
    </v-tooltip>
  </div>
</template>
<script>
  import Effect from '@/views/blogger/records/components/Effect.jsx'
  export default {
    components: {
      Effect
    },
    props: {
      value: {
        type: Object,
      },
      showList: {
        type: Array,
      }
    }
  }
</script>